export default '/api' as const;
